import { Badge } from '@mui/material'
import clsx from 'clsx'
import { FunctionComponent } from 'react'
import { isMobile } from 'react-device-detect'
import SVG from 'react-inlinesvg'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { isCordova } from '../../util'

interface Props {
  id?: string
  onClick?: () => void
  isOpen?: boolean
  text: string
  icon: string
  imageIcon?: any
  to: string
  isHidden?: boolean
  disabled?: boolean
  badgeCount?: number
  external?: boolean
}

const RootMenuItem: FunctionComponent<Props> = ({
  imageIcon, text, to, icon,
  isHidden = false, isOpen, id,
  onClick, disabled, badgeCount,
  external = false
}) => {
  const location = useLocation()

  const menuEntryIcon = !imageIcon ? (
    <span className="image-icon">
      <i className={icon} />
    </span>
  )
    : (
      <span className="image-icon">
        <SVG src={imageIcon} />
      </span>
    )

  const content = (
    <div className="root-menu-row" data-tip={!isMobile && !isCordova() && !isOpen ? text : null} data-for="main-tooltip" data-place="right">
      { menuEntryIcon }
      <span
        className={clsx('root-menu-text', isOpen && 'is-open')}
      >
        {' '}
        { text }
      </span>
    </div>
  )
  let active = location.pathname === to

  if (to === '/checklists') {
    active = location.pathname.startsWith('/checklists')
  }

  let link = to && !disabled ? (
    <Link to={to}>
      { content }
    </Link>
  ) : (
    <a>
      { content }
    </a>
  )

  if (external) {
    link = <a href="#" onClick={() => window.open(to, '_system')}>{content}</a>
  }

  return (
    <div
      className={clsx('root-menu-item', active && 'is-active', isHidden && 'is-hidden', disabled && 'is-disabled')}
      id={id}
      onClick={disabled ? undefined : onClick}
    >
      <Badge badgeContent={badgeCount} color="primary">
        { link }
      </Badge>
    </div>
  )
}

export default RootMenuItem
